'use strict';
import angular from 'angular';

angular.module('exceptionlogs.services', [])
    .service('ExceptionLogsService', ExceptionLogsService)
    .service('ExceptionLogsFactory', ExceptionLogsFactory);

ExceptionLogsService.$inject = ['ExceptionLogsFactory', '$q'];
function ExceptionLogsService(ExceptionLogsFactory, $q) {
    var service = {};
    service.ExceptionLogs = function(date) {
        var deferred = $q.defer();
        if(date){
            var dateObj = new Date(date);
        }
        var params = {
            'month': date ? dateObj.getMonth()+1 : date,
            'year': date ? dateObj.getFullYear() : date
        };
        ExceptionLogsFactory.ExceptionLogs().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getExceptionLog = function(logId) {
        let params = {
            id: logId
        }
        let deferred = $q.defer();
        ExceptionLogsFactory.ExceptionLog().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };
    return service;
}

ExceptionLogsFactory.$inject = ['$resource', 'AppConfig'];
function ExceptionLogsFactory($resource, AppConfig) {
    var factory = {};
    factory.ExceptionLogs = function() {
        return $resource(AppConfig.IO_API_URL + 'exceptionLogs/logsForMonth', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        })
    };
    factory.ExceptionLog = function() {
        return $resource(AppConfig.IO_API_URL + 'exceptionLogs/exceptionLog', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        })
    };
    return factory;
}